import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  isOn: false
};

export function ExperimentPosterReducer(
  state = { experimentPoster: [] },
  action
) {
  let currentExperimentPoster;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_EXPERIMENT_POSTER" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("experimentPoster")
      ) {
        currentExperimentPoster =
          state.protocolSection.scene.apparatus.experimentPoster[
            findIndex(state.protocolSection.scene.apparatus.experimentPoster, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_EXPERIMENT_POSTER":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("experimentPoster")) {
        protocolSection.scene.apparatus.experimentPoster = [
          ...protocolSection.scene.apparatus.experimentPoster,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.experimentPoster = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
      case "EXPERIMENT_POSTER_TOGGLE_ON":
        //Create new obj from template state
        // let newObj = { ...templateState, ...action.payload.props };
       
        currentExperimentPoster = state.protocolSection.scene.apparatus.experimentPoster[action.payload.id-1];
        currentExperimentPoster.isOn = !currentExperimentPoster.isOn;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
  
    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('experimentPoster')) {
        protocolSection.scene.apparatus.experimentPoster =
          action.payload.lastState.scene.apparatus.experimentPoster;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
